<template>
    <div class="mini-cart" v-show="ui.minicartVisible" @click.stop>
        <div class="title">
            <a href="" class="close icon-close" @click.prevent="close"></a>
        </div>

        <div class="content">
            <table class="cart-products">
                <thead>
                    <tr>
                        <td colspan="3"></td>
                    </tr>
                </thead>
                <tbody v-for="cartProduct in cart.products" :key="cartProduct.code">
                    <tr class="cartproduct">
                        <td>{{ cartProduct.name }}</td>
                        <td><span class="code">{{ cartProduct.code }}</span></td>
                        <td v-if="!ui.hidePrices" class="price">
                            <span v-if="cartProduct.price! > 0">
                                {{ cartProduct.price!.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}
                            </span>
                        </td>
                    </tr>

                    <template v-if="cartProduct.accessories!.length > 0">
                        <tr class="compact accessory" v-for="accessory in cartProduct.accessories" :key="accessory.code">
                            <td>{{ accessory.name }}</td>
                            <td><span class="code">{{ accessory.code }}</span></td>
                            <td v-if="!ui.hidePrices" class="price">
                                <span v-if="accessory.price! > 0">
                                    {{ accessory.price!.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}
                                </span>
                            </td>
                        </tr>
                    </template>
                </tbody>

                <tbody class="summary" v-if="cart.priceSummary && !ui.hidePrices">
                    <tr>
                        <td colspan="2" v-html="ui.t('totalNoTax')"></td>
                        <td v-if="!ui.hidePrices" class="price">{{ cart.priceSummary.subTotal.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" v-html="ui.t('taxTotal')"></td>
                        <td class="price">{{ cart.priceSummary.tax.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}</td>
                    </tr>
                </tbody>
                <tbody class="grand-total" v-if="cart.priceSummary && !ui.hidePrices">
                    <tr>
                        <td colspan="2" v-html="ui.t('grandTotal')"></td>
                        <td class="price">{{ cart.priceSummary.grandTotal.toFixed(cart.numberOfDecimals) }} {{ cart.currencyCode }}</td>
                    </tr>
                </tbody>
            </table>

            <template v-if="cart.planCode">
                <h2 class="h2" v-html="ui.t('planCode')"></h2>

                <label class="form-group plan-code">
                    <div class="row">
                        <div class="col-12">
                            <input type="text" ref="planCode" @click.prevent="copyCode" readonly v-model="cart.planCode" class="form-control" />

                            <span class="input-tip" v-if="codeWasCopied" v-html="ui.t('codeWasCopied')"></span>
                        </div>
                        <!-- <div class="col-3">
                            <a href="#" class="button-link" @click.prevent="copyCode" v-html="ui.t('copyPlanCode')"></a>
                        </div> -->
                    </div>
                </label>
            </template>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { ref, useTemplateRef } from 'vue';
import { useCart, useUI } from '../store';

const codeWasCopied = ref(false);
let codeWasCopiedTimer: number | undefined = undefined;

const planCode = useTemplateRef("planCode")

const { ui } = useUI();
const { cart } = useCart();

function close() {
    ui.minicartVisible = false;
}

function copyCode() {
    var codeInput = planCode.value as HTMLInputElement;

    codeInput.select();

    document.execCommand("copy");

    window.getSelection()!.removeAllRanges();

    codeWasCopied.value = true;

    clearTimeout(codeWasCopiedTimer);

    codeWasCopiedTimer = setTimeout(() => codeWasCopied.value = false, 3000);
}
</script>
